import axios from 'axios';

// Gunakan environment variable atau fallback ke RELATIVE URL
// Di production, VITE_API_URL harus '/api'
// Di local, Vite proxy akan handle
const API_URL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({
  baseURL: API_URL,
  // Wajib true: auth backend berbasis session cookie (bukan Bearer token),
  // jadi cookie httpOnly-nya harus ikut dikirim di tiap request.
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
  },
});

// Response interceptor - kalau session expired/invalid (401), lempar balik
// ke halaman login admin — tapi jangan sampai loop kalau memang lagi di
// halaman publik atau lagi memeriksa status login itu sendiri (/auth/me).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      if (currentPath.startsWith('/admin') && !currentPath.includes('/admin/login') && !isAuthCheck) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Helper function untuk upload URL
export function uploadUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Gunakan relative URL untuk uploads
  return `/uploads/${path}`;
}

export default api;
